<p-listbox
  #listbox
  [options]="options"
  [(ngModel)]="values"
  (ngModelChange)="onValueChange($event)"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  [filter]="filter"
  [filterBy]="filterBy"
  [multiple]="multiple"
  [disabled]="disabled"
  [showToggleAll]="multiple"
  [emptyMessage]="'No result found' | translate"
  [emptyFilterMessage]="'No result found' | translate"
  [id]="key"
  [name]="key ?? ''"
  [metaKeySelection]="metaKeySelection"
  [styleClass]="class"
  [listStyle]="{ 'max-height': maxHeight }"
>
  <ng-template let-item pTemplate="item" *ngIf="itemTemplate">
    <ng-container
      [ngTemplateOutlet]="itemTemplate"
      [ngTemplateOutletContext]="{ $implicit: item }"
    />
  </ng-template>
</p-listbox>
